import styled from 'styled-components'

const SubTitle = styled.h3`
  font-size: 0.67em;
`
export default SubTitle
